import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModuleService {

  constructor(private http: HttpClient) { }

  ReadAllModule(otp): Observable<any> {
    return this.http.post<number>(`${environment.apiIotUrl}/module/read/all`, {otp: otp});
  }

  ReadModuleByRegion(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/module/read/region`, params);
  }

  UpdateModule(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/module/update`, params);
  }

  ReadModuleByUser(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/module/read/user`, params);
  }
}
